<template>
  <div class="layout-main-container">
    <div class="layout-main">
      <BookGrid ref="bookGrid" :books="books" :pageSize="pageSize" :totalBooksCount="totalBooksCount"
        :selectableBooks="false" :canFilterByOwners="true" @filterTriggered="filterBooks"
        @pageRequested="pageRequest => loadPage(pageRequest.number, pageRequest.filter)" />
    </div>
  </div>
</template>

<script setup>
import { onErrorCaptured, onMounted, ref } from 'vue'
import { handleError } from '@/helpers/ErrorHandler'
import { useToast } from "primevue/usetoast"
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import BookGrid from '@/components/BookGrid'
import bookService from '@/service/BookService'

const authStore = useAuthStore()
const toast = useToast()
const i18n = useI18n()

const bookGrid = ref(null)

const books = ref([])

const pageSize = 20
const totalBooksCount = ref(0)

onMounted(async () => {
  try {
    await loadPage(0)
  } catch (error) {
    handleError(authStore, toast, i18n, error)
  }
})

onErrorCaptured((err, instance, info) => {
  return handleError(authStore, toast, i18n, err, instance, info)
})

const loadPage = async (number, filter) => {
  const response = await bookService.getAvailableBooks(number, pageSize, filter)
  books.value = response.collection
  totalBooksCount.value = response.total
}

const filterBooks = async (filter) => {
  await loadPage(0, filter)
}

</script>

<style scoped></style>